const routes = [
    {
        name: 'agendaProListagem',
        path: '/listagem',
        meta: {
            requiresAuth: true,
            title: 'Meus Agendamentos'
        },
        component: () => import('../views/Listagem')
    },
    {
        name: 'agendaProAgendar',
        path: '/agendar',
        meta: {
            requiresAuth: true,
            title: 'Novo Agendamento'
        },
        component: () => import('../views/MeusAgendamentos')
    }
]

export default routes
